module.exports = __webpack_public_path__ + "static/img/thumb_17.237189d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_17.png
// module id = KiX1
// module chunks = 0